module.exports = __webpack_public_path__ + "media/src/images/icons/notice/yellow-c70050343697ac5fb2565c2a562c5f42.svg";